import type { TrackingService } from '@/features/tracking/TrackingService'
import type { WorkspaceMember } from '@/features/iam/members/WorkspaceMember'
import type { UserData } from '@/features/iam/users/UserData'

export class NoOpTrackingService implements TrackingService {
  identify(member: WorkspaceMember, _userData: UserData) {
    console.debug('Identifying as', member)
  }

  reset() {
    console.debug('resetting member')
  }

  static create() {
    return new NoOpTrackingService()
  }
}
